var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPwdUnchecked = function SvgPwdUnchecked(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 14.6667C9.84094 14.6667 11.5076 13.9205 12.714 12.7141C13.9205 11.5076 14.6667 9.84097 14.6667 8.00004C14.6667 6.15911 13.9205 4.49244 12.714 3.28599C11.5076 2.07957 9.84094 1.33337 8.00001 1.33337C6.15908 1.33337 4.49241 2.07957 3.28596 3.28599C2.07954 4.49244 1.33334 6.15911 1.33334 8.00004C1.33334 9.84097 2.07954 11.5076 3.28596 12.7141C4.49241 13.9205 6.15908 14.6667 8.00001 14.6667Z",
    stroke: "#A6A9B6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 8L7.33334 10L11.3333 6",
    stroke: "#A6A9B6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPwdUnchecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pwd-unchecked.efc630ba.svg";